<div class="flex flex-row justify-between pt-12">
    <div class="flex flex-row">
        <form [formGroup]="profileForm()!">
            <app-image-selector
                formControlName="image"
                [defaultImagePath]="'/assets/images/avatar.svg'"
                [isAvatar]="true" />
        </form>
        <div class="flex flex-col pl-8 gap-y-4">
            <div class="flex flex-col">
                <span class="custom-text">{{ 'givenName' | transloco }}</span>
                <app-input-text
                    class="w-40"
                    [errors]="[!profileForm().value.givenName ? 'required' : '']"
                    [inputFormControl]="profileForm().controls.givenName"
                    [placeholder]="securityService.meSignal()!.givenName" />
            </div>
            <div class="flex flex-col">
                <span class="custom-text">{{ 'address' | transloco }}</span>
                <app-input-text
                    class="w-72"
                    [errors]="[profileForm().controls.address.errors ? 'maxLengthErrorMessage' : '']"
                    [inputFormControl]="profileForm().controls.address"
                    [placeholder]="'address' | transloco" />
            </div>
        </div>
    </div>
    <div class="flex flex-col gap-y-4 pr-16">
        <div class="flex flex-col">
            <span class="custom-text">{{ 'name' | transloco }}</span>
            <app-input-text
                class="w-40"
                [errors]="[!profileForm().value.familyName ? 'required' : '']"
                [inputFormControl]="profileForm().controls.familyName"
                [placeholder]="securityService.meSignal()!.familyName" />
        </div>
        <div class="flex flex-col">
            <span class="custom-text">{{ 'lang' | transloco }}</span>
            <app-select
                class="w-40"
                [defaultValue]="defaultSelectValue()"
                [(options)]="languageOptions"
                (optionSelected)="selectLang($event)" />
        </div>
    </div>
</div>
